import { useEffect, useState } from "react";
import { Select } from "antd";
import { useSelector } from "react-redux";

const { Option } = Select;

const Dropdown = ({ fetchData, placeholder, onChange, includeAll = false, mode = "default", }) => {
  const [options, setOptions] = useState([]);
  const token = useSelector((state) => state.auth.token);
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const data = await fetchData();
        const formattedOptions = data.map((item) => ({
          id: item.id,
          name: item.name.trim(),
        }));
        if (includeAll) {
          setOptions([{ id: "all", name: "All" }, ...formattedOptions]);
        } else {
          setOptions(formattedOptions);
        }
      } catch (error) {
        console.error("Error loading options:", error);
      }
    };

    fetchOptions();
  }, [fetchData, includeAll, token]); 

  const handleSelectChange = (value) => {
    onChange(value); // Pass the selected value back to the parent component
  };

  return (
    <Select
      placeholder={placeholder || "--select--"}
      onChange={handleSelectChange}
      mode={mode === "default" ? undefined : mode}
    >
      {options.map((option) => (
        <Option key={option.id} value={option.name}>
          {option.name}
        </Option>
      ))}
    </Select>
  );
};
export default Dropdown;
